<template>
  <!-- <div class="loading">加载中...........</div> -->
  <div class="loading">
    <img src="../../assets/global_handle.gif" />
  </div>
</template>
<script>
export default {
  name: "apploading",
  data() {
    return {};
  },
};
</script>
<style scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.loading img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 0.96rem;
  height: 0.96rem;
}
</style>


// WEBPACK FOOTER //
// src/components/public/loading.vue